module.exports = __webpack_public_path__ + "img/8363af6.jpg";